export const EmptyState = (props) => {
    return (
        <div className="empty-state-container">
            <i className={props.iconClass ?? ""} color={props.iconColor ?? "#748194"}></i>
            { props.message && <p>{props.message}</p> }
        </div>
    )
}